import React, { useState } from "react";
import { Player, BigPlayButton } from "video-react";
import { Button } from "@/shared/ui/Button";
import { Center } from "@/shared/ui/Blocks";
import { Icon } from "@/shared/ui/Icon";
// AccessRequest component was removed (not used)

interface ListItem {
  title: string;
  description: string;
  button?: {
    title: string;
    action: () => void;
  };
}

interface EmptyStateContent {
  notice: {
    title: string;
    subtitle: string;
  };
  subtitle: string;
  list?: ListItem[];
  thumbnail?: string;
  video?: string;
}

interface NoRightsProps {
  pageTitle?: string;
  emptyStateContent?: EmptyStateContent;
}

export default function NoRights({ emptyStateContent }: NoRightsProps) {
  return (
    <Center className="p-8">
      <div className="flex items-start gap-4 rounded-lg bg-yellow-100 p-4">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-200">
          <Icon icon="Bell" className="text-yellow-500" />
        </div>
        <div className="flex-1">
          <h5 className="mb-1 text-base font-semibold text-gray-900">
            You currently don't have access to this feature.
          </h5>
          <p className="text-sm text-gray-600">
            To fully experience AssessioAI, please ask your workspace admin for
            access.
          </p>
        </div>
      </div>
    </Center>
  );
}
